import { ReactElement } from 'react'

import { Flex, MenuItem, Text } from '@chakra-ui/react'

export const MenuSelectItem = ({
  label,
  textColor = 'rgb(26, 32, 44)',
  fontSize = '14px',
  showDivider = true,
  isDisabled = false,
  icon,
  bgColor,
  ...menuItemProps
}: {
  label: string
  textColor?: string
  fontSize?: string
  showDivider?: boolean
  isDisabled?: boolean
  icon?: ReactElement
  bgColor?: string
  [key: string]: unknown
}) => (
  <MenuItem
    _disabled={{
      opacity: bgColor ? 1 : 0.5,
    }}
    _focus={{
      backgroundColor: bgColor || 'rgba(0,0,0,0.03)',
    }}
    _hover={{
      backgroundColor: bgColor || 'rgba(0,0,0,0.03)',
    }}
    backgroundColor={bgColor}
    borderBottom={showDivider ? '2px solid rgba(0,0,0,0.03)' : 'auto'}
    isDisabled={isDisabled}
    px='18px'
    py='10px'
    {...menuItemProps}
  >
    <Flex alignItems='center' gap='8px'>
      {icon}
      <Text
        color={textColor}
        fontSize={fontSize}
        height='100%'
        letterSpacing='-0.2px'
      >
        {label}
      </Text>
    </Flex>
  </MenuItem>
)
